import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getFormatting } from '@its/components/lib/util/i18n';

const getFormattedMessage = ({ id, description, defaultMessage, values }) => (
  <FormattedMessage
    id={id}
    description={description}
    defaultMessage={defaultMessage}
    values={values}
  >
    { getFormatting(defaultMessage) }
  </FormattedMessage>
);

export const Set = getFormattedMessage({
  id: 'SET',
  description: 'Set text',
  defaultMessage: 'Set',
});

export const SetCurrentPage = getFormattedMessage({
  id: 'SET_CURRENT_PAGE',
  description: 'Set current page text',
  defaultMessage: 'Set current page',
});

export const generalDataText = getFormattedMessage({
  id: 'GENERAL_DATA',
  description: 'General data section',
  defaultMessage: 'General data',
});

export const TechnicalDataText = getFormattedMessage({
  id: 'TECHNICAL_DATA',
  description: 'Technical data section',
  defaultMessage: 'Techincal data',
});

export const ExampleName = getFormattedMessage({
  id: 'EXAMPLE_NAME',
  description: 'Example display name',
  defaultMessage: 'Eg: Eurotranciatura\'s display',
});

export const ShortDescription = getFormattedMessage({
  id: 'SHORT_DESCRIPTION',
  description: 'Short description title',
  defaultMessage: 'Short Description',
});

export const ExampleLocation = getFormattedMessage({
  id: 'EXAMPLE_LOCATION',
  description: 'Example location',
  defaultMessage: 'Eg. Bollate',
});

export const Location = getFormattedMessage({
  id: 'LOCATION',
  description: 'Location title',
  defaultMessage: 'Location',
});

export const ExampleTechnicalName = getFormattedMessage({
  id: 'EXAMPLE_TECHNICAL_NAME',
  description: 'Example of technal name',
  defaultMessage: 'Eg: Mario Rossi',
});

export const TechnicalName = getFormattedMessage({
  id: 'TECHNICAL_NAME',
  description: 'Indicate technical name',
  defaultMessage: 'Technical name',
});

export const FrameNumber = getFormattedMessage({
  id: 'FRAME_NUMBER',
  description: 'Indicate display frame number',
  defaultMessage: 'Page number',
});

export const Template = getFormattedMessage({
  id: 'TEMPLATE_ID',
  description: 'template title',
  defaultMessage: 'Template',
});

export const FrameTimerText = getFormattedMessage({
  id: 'ITERATION_FRAME_ID',
  description: 'iteration title for frames',
  defaultMessage: 'Tempo permanenza pagina',
});

export const FrameOrderText = getFormattedMessage({
  id: 'FRAME_ORDER',
  description: 'order for frames',
  defaultMessage: 'Move to position...',
});

export const Timer = getFormattedMessage({
  id: 'ITERATION_ID',
  description: 'iteration title',
  defaultMessage: 'Timer',
});

export const IsActive = getFormattedMessage({
  id: 'IS_ACTIVE',
  description: 'Indicate active status',
  defaultMessage: 'Active',
});

export const Notes = getFormattedMessage({
  id: 'NOTES',
  description: 'Notes title',
  defaultMessage: 'Notes',
});

export const ExampleIpAddress = getFormattedMessage({
  id: 'EXAMPLE_IPADDRESS',
  description: 'Example of Ip Address',
  defaultMessage: 'Eg: 192.168.20.30',
});

export const Ipv4LAN1 = getFormattedMessage({
  id: 'IPV4_LAN1',
  description: 'Ip address first LAN',
  defaultMessage: 'IPv4 first LAN',
});

export const ExamplePort = getFormattedMessage({
  id: 'EXAMPLE_PORT',
  description: 'Example port',
  defaultMessage: 'Eg: 20000',
});

export const PortLAN1 = getFormattedMessage({
  id: 'PORT_LAN1',
  description: 'Display port',
  defaultMessage: 'Port first LAN',
});

export const ExampleMacAddress = getFormattedMessage({
  id: 'EXAMPLE_MACADDRESS',
  description: 'Example MAC Address',
  defaultMessage: 'Eg: 3D:F2:C9:A6:B3:4F',
});

export const InvalidIpAddress = getFormattedMessage({
  id: 'INVALID_IPADDRESS',
  description: 'Notify invalid ip address format',
  defaultMessage: 'Invalid IP Address',
});

export const InvalidMacAddress = getFormattedMessage({
  id: 'INVALID_MACADDRESS',
  description: 'Notify invalid mac address format',
  defaultMessage: 'Invalid MAC Address',
});

export const InvalidVersion = getFormattedMessage({
  id: 'INVALID_VERSION',
  description: 'Notify invalid version address format',
  defaultMessage: 'Invalid version',
});

export const MacAddressLAN1 = getFormattedMessage({
  id: 'MACADDRESS_LAN1',
  description: 'MAC Address LAN 1',
  defaultMessage: 'Mac address first LAN',
});

export const MacAddressLAN2 = getFormattedMessage({
  id: 'MACADDRESS_LAN2',
  description: 'MAC Address LAN 2',
  defaultMessage: 'Mac address second LAN',
});

export const Ipv4LAN2 = getFormattedMessage({
  id: 'IPV4_LAN2',
  description: 'Ip address second LAN',
  defaultMessage: 'IPv4 second LAN',
});

export const PortLAN2 = getFormattedMessage({
  id: 'PORT_LAN2',
  description: 'Display port',
  defaultMessage: 'Port seoond LAN',
});

export const ExampleSerialNumber = getFormattedMessage({
  id: 'EXAMPLE_SERIAL_NUMBER',
  description: 'Display port',
  defaultMessage: 'Eg. 11111111',
});

export const SerialNumber = getFormattedMessage({
  id: 'SERIAL_NUMBER',
  description: 'Serial number',
  defaultMessage: 'Serial number',
});

export const ExampleFirmwareVersion = getFormattedMessage({
  id: 'EXAMPLE_FIRMWARE_VERSION',
  description: 'Example firmware version',
  defaultMessage: 'Eg: 1.0.1',
});

export const FirmwareVersion = getFormattedMessage({
  id: 'FIRMWARE_VERSION',
  description: 'Firmware version',
  defaultMessage: 'Firmware version',
});

export const Frequency = getFormattedMessage({
  id: 'FREQUENCY',
  description: 'Timer frequency',
  defaultMessage: 'Frequency (sec.)',
});

export const ExampleFrequency = getFormattedMessage({
  id: 'EXAMPLE_FREQUENCY',
  description: 'Example frequency',
  defaultMessage: 'Eg: 30',
});

export const ExampleTimerName = getFormattedMessage({
  id: 'EXAMPLE_TIMER_NAME',
  description: 'Example timer name',
  defaultMessage: 'Eg: Fast timer',
});

export const ExampleTemplateName = getFormattedMessage({
  id: 'EXAMPLE_TEMPLATE_NAME',
  description: 'Example template name',
  defaultMessage: 'Eg: 2 lines display',
});

export const FieldNum = getFormattedMessage({
  id: 'FIELD',
  description: 'Map field',
  defaultMessage: 'Field',
});

export const ExampleFieldNum = getFormattedMessage({
  id: 'EXAMPLE_FIELD',
  description: 'Example Map field',
  defaultMessage: 'Eg: 1',
});

export const ExampleNumber = getFormattedMessage({
  id: 'EXAMPLE_NUMBER',
  description: 'Example number',
  defaultMessage: 'Eg: 1',
});

export const RowNum = getFormattedMessage({
  id: 'ROW',
  description: 'Map row',
  defaultMessage: 'Row',
});

export const ExampleRowNum = getFormattedMessage({
  id: 'EXAMPLE_ROW',
  description: 'Example Map row',
  defaultMessage: 'Eg: 2',
});

export const Width = getFormattedMessage({
  id: 'WIDTH',
  description: 'Map width',
  defaultMessage: 'Width',
});

export const ExampleWidth = getFormattedMessage({
  id: 'EXAMPLE_WIDTH',
  description: 'Example map field width',
  defaultMessage: 'Eg: 10',
});

export const DynamicField = getFormattedMessage({
  id: 'DYNAMIC_FIELD',
  description: 'Dynamic field toggle',
  defaultMessage: 'Dynamic Field',
});

export const AdapterNum = getFormattedMessage({
  id: 'ADAPTER_NUM',
  description: 'AdapterNum title',
  defaultMessage: 'Network adapter',
});

export const Sliding = getFormattedMessage({
  id: 'SLIDING',
  description: 'Sliding title',
  defaultMessage: 'Sliding',
});

export const MultiCharacter = getFormattedMessage({
  id: 'MULTI_CHARACTER',
  description: 'MultiCharacter title',
  defaultMessage: 'Special font',
});

export const Intermittence = getFormattedMessage({
  id: 'INTERMITTENCE',
  description: 'Intermittence title',
  defaultMessage: 'Intermittence',
});

export const Indicator = getFormattedMessage({
  id: 'INDICATOR',
  description: 'Indicator title',
  defaultMessage: 'Indicator',
});

export const DisplayTitle = getFormattedMessage({
  id: 'DISPLAY',
  description: 'Display title',
  defaultMessage: 'Display',
});

export const Configuration = getFormattedMessage({
  id: 'CONFIGURATION',
  description: 'Configuration title',
  defaultMessage: 'Configuration',
});

export const RowNumber = rowNum => getFormattedMessage({
  id: 'ROW_NUM',
  description: 'Row title',
  defaultMessage: 'Row {rowNum}',
  values: { rowNum },
});

export const FrameNum = frameNum => getFormattedMessage({
  id: 'FRAME_NUM',
  description: 'Frame title',
  defaultMessage: 'Page {frameNum}',
  values: { frameNum },
});

export const Positive = getFormattedMessage({
  id: 'POSITIVE',
  description: 'Positive title',
  defaultMessage: 'Positive',
});

export const Negative = getFormattedMessage({
  id: 'NEGATIVE',
  description: 'Negative title',
  defaultMessage: 'Negative',
});

export const Help = getFormattedMessage({
  id: 'HELP',
  description: 'Help title',
  defaultMessage: 'Help',
});

export const Tutorial = getFormattedMessage({
  id: 'TUTORIAL',
  description: 'Tutorial for first line',
  defaultMessage: 'Questa guida si applica solo alla prima riga del display\nLa modalità predefinita è TESTO FISSO.\nPer scrivere una singola riga senza effetti speciali è sufficiente scrivere il testo da visualizzare.\nPer scrivere righe multiple, impostare al termine di ogni riga tranne l\'ultima il carattere § (sopra la ù a fianco all\'invio).\nPer attribuire ad ogni riga effetti speciali impostare prima della riga la seguenza di caratteri che impostano la modalità scelta.\nLe modalità sono:\n- font (carattere) -> i valori consentiti sono: normal (predefinito) e big. Esempio: #font=big;\n- type (modalità di visualizzazione) -> valori consentiti sono: static (predefinito) che permette la visualizzazione di testo statico, scroll che visualizza il testo in modalità scorrimento. E\' possibile anche specificare la velocità di scorrimento esprimendo un valore tra 1 e 255. E\' inoltre possibile indicare il tempo in secondi di permanenza della riga sul monitor nella modalità static. Esempio: #type=scroll,10; oppure #type=static,2- effect (effetto speciale) -> valori consentiti sono: blink (che permette di far lampeggiare il testo) stop (permette di tenere bloccato il testo della riga evitando la ripetizione). Esempio #effect:stop;\n\nNon specificando i vari attributi per le righe successive saranno mantenute le ultime impostazioni inserite.\n\nESEMPIO COMPLETO:\nVogliamo scrivere 4 righe, la prima a scorrimento a velocità 50/255 a carattere grande, la seconda e la terza carattere normale con blink che rimanga impressa per 10 secondi e la quarta con carattere grande con stop, potremmo scrivere il seguente comando:\n#font=big;#type=scroll,50;TESTO CHE SCORRE SULLA PRIMA RIGA§#font=normal;#type=static,10;#effect:blink;TESTO DA METTERE SULLA SECONDA RIGA§TESTO DA METTERE SULLA TERZA RIGA§#font=big;#effect:stop;QUARTA RIGA CON STOP\n\nSe il campo è ottenuto da un plugin, sarà compito del plugin stesso creare il testo con le modalità sopra citate.',
});

export const HelpIntroduction = getFormattedMessage({
  id: 'HELP_INTRODUCTION',
  description: 'Help introduction',
  defaultMessage: 'Per procedere con la creazione di un display è necessario seguire i brevi passi riportati di seguito:',
});

export const CreateTimer = getFormattedMessage({
  id: 'CREATE_TIMER',
  description: 'Title of timers\' tutorial',
  defaultMessage: 'Creazione timer',
});

export const CreateTemplate = getFormattedMessage({
  id: 'CREATE_TEMPLATE',
  description: 'Title of templates\' tutorial',
  defaultMessage: 'Creazione template',
});

export const CreateDisplay = getFormattedMessage({
  id: 'CREATE_DISPLAY',
  description: 'Title of displays\' tutorial',
  defaultMessage: 'Creazione display',
});

export const CreateTimerDescription = getFormattedMessage({
  id: 'CREATE_TIMER_DESCRIPTION',
  description: 'Tutorial for timers',
  defaultMessage: 'I timer ti consentono di stabilire con che periodicità è necessario aggiornare i display. Imposta il timer del display interessato pari al tempo di aggiornamento del campo maggiormente soggetto a cambiamenti.\nCrea un timer cliccando sull\'apposita voce di menu.',
});

export const CreateTemplateDescription = getFormattedMessage({
  id: 'CREATE_TEMPLATE_DESCRIPTION',
  description: 'Tutorial for templates',
  defaultMessage: 'I template ti permettono di costruire un display specificando le sue caratteristiche. I template rispecchiano essenzialmente la struttura dei vari modelli di display: è necessario descrivere ogni singolo campo nei particolari per permettere la creazione del suo modello virtuale.\nCrea un template cliccando sull\'apposita voce di menu e aggiungi i campi da cui è costituito.',
});

export const CreateDisplayDescription = getFormattedMessage({
  id: 'CREATE_DISPLAY_DESCRIPTION',
  description: 'Tutorial for displays',
  defaultMessage: 'La sezione display ti permette di creare effettivamente i display in uso nei vari reparti. Imposta il numero di pagine per ottenere un\'alternanza di testi da visualizzare dopo l\'intervallo dei timer. Una volta creato un display è possibile selezionarlo per modificare i dati che dovrà mostrare.\nCrea un display cliccando sull\'apposita voce di menu.',
});

export const CanCreateDisplay = getFormattedMessage({
  id: 'CAN_CREATE_DISPLAY',
  description: 'Tutorial finished',
  defaultMessage: 'Hai terminato il tutorial, puoi iniziare ora ad impostare i display.',
});

export const Department = getFormattedMessage({
  id: 'DEPARTMENT_ID',
  description: 'Department title',
  defaultMessage: 'Department',
});

export const Departments = getFormattedMessage({
  id: 'DEPARTMENTS',
  description: 'Departments title',
  defaultMessage: 'Departments',
});

export const ExampleDepartment = getFormattedMessage({
  id: 'EXAMPLE_DEPARTMENT',
  description: 'Example department name',
  defaultMessage: 'Eg: Caronno',
});

export const ipv4LAN1NotReachable = getFormattedMessage({
  id: 'IPV4_LAN1_NOT_REACHABLE',
  description: 'Ip address first LAN not reachable',
  defaultMessage: '(!!!) IPv4 first LAN',
});

export const ipv4LAN2NotReachable = getFormattedMessage({
  id: 'IPV4_LAN2_NOT_REACHABLE',
  description: 'Ip address second LAN not reachable',
  defaultMessage: '(!!!) IPv4 second LAN',
});



/** WEBPACK FOOTER **
 ** ./src/i18n/intl.js
 **/